"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("../index.less");
var _index2 = _interopRequireDefault(require("@/components/reTitle/index"));
var _news = require("@/api/news/news");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      tabsActNum: 1,
      titleInfo: {},
      newTypeList: [{}, {}],
      reNewsInfo: [{}],
      totalNum: 10,
      page: {
        pageSize: 12,
        pageNumber: 1
      },
      content: "",
      newsInfo: {
        newsTitle: "数据加载中",
        createdDate: "数据加载中",
        views: "",
        newsContent: "",
        lastId: "",
        lastTitle: "",
        nextId: "",
        nextTitle: ""
      },
      backPath: '/teacherIndex',
      uploadFileList: []
    };
  },
  methods: {
    // 获取新闻详情通过ID
    getNewsDetail: function getNewsDetail() {
      var _this = this;
      (0, _news.getNewsById)({
        id: this.$route.query.id
      }).then(function (res) {
        var data = res.data;
        _this.newsInfo = data;
        _this.uploadFileList = data.uploadFileList;
      });
    },
    handleSizeChange: function handleSizeChange() {},
    handleCurrentChange: function handleCurrentChange() {},
    tabs: function tabs(index) {
      this.tabsActNum = index;
    },
    download: function download(url, name) {
      if (url == null || url == "") {
        this.$message.error("暂无材料");
        return false;
      } else {
        window.open(url);
        // const a = document.createElement("a");
        // fetch(url)
        //   .then(res => {
        //     res.blob();
        //   })
        //   .then(blob => {
        //     a.href = URL.createObjectURL(blob);
        //     a.download = name; // 下载文件的名字
        //     document.body.appendChild(a);
        //     a.click();
        //   });
      }
    },
    changeNews: function changeNews(id) {
      this.$router.push({
        path: "/teacherNewsDetail",
        query: {
          id: id
        }
      });
      window.location.reload();
    }
  },
  created: function created() {
    var v = this.$route;
    this.titleInfo.sec = v.meta.title;
    this.titleInfo.path = v.fullPath;
    this.getNewsDetail();
  },
  components: {
    RealTitle: _index2.default
  }
};